module.exports = __webpack_public_path__ + "img/jtl.b5fca1f1.svg";